// extracted by mini-css-extract-plugin
export var askAiIcon = "_h7-9";
export var container = "_h7-0";
export var groupSeparator = "_h7-a";
export var highlight = "_h7-4";
export var resultIcon = "_h7-5";
export var resultItem = "_h7-7";
export var resultSubtitle = "_h7-3";
export var resultTitle = "_h7-2";
export var resultsList = "_h7-1";
export var searchGroup = "_h7-6";
export var selected = "_h7-8";